type LogoProps = { light?: boolean; compact?: boolean };

export default function Logo({ light = false, compact = false }: LogoProps) {
  return (
    <div className={`brand ${light ? "brand--light" : ""}`} aria-label="Thầy Linh dạy Toán">
      <span className="brand__mark" aria-hidden="true">
        <span>+</span>
        <i />
      </span>
      {!compact && (
        <span className="brand__copy">
          <strong>THẦY LINH</strong>
          <small>DẠY TOÁN</small>
        </span>
      )}
    </div>
  );
}
